/* eslint-disable react-refresh/only-export-components */
/* eslint-disable import/no-internal-modules */
/* eslint-disable import/no-cycle */
import { lazy } from 'react';
import { createBrowserRouter } from 'react-router-dom';

import { routes } from '~/shared/config/routes';

import { RootLayout } from './layouts/RootLayout';
import ScrollToTop from '~/features/scrolltotop/scrollToTop';

const DashboardLayout = lazy(() =>
  import('./layouts/DashboardLayout').then((module) => ({
    default: module.DashboardLayout,
  })),
);

const HomePage = lazy(() =>
  import('~/pages/home/ui/HomePage').then((module) => ({
    default: module.HomePage,
  })),
);

const DashboardPage = lazy(() =>
  import('~/pages/dashboard/ui/DashboardPage').then((module) => ({
    default: module.DashboardPage,
  })),
);

const CreateCoursePage = lazy(() =>
  import('~/pages/create-course/ui/CreateCoursePage').then((module) => ({
    default: module.CreateCoursePage,
  })),
);

const CardsManagingPage = lazy(() =>
  import('~/pages/cards-managing/ui/CardsManagingPage').then((module) => ({
    default: module.CardsManagingPage,
  })),
);

const MyCoursesPage = lazy(() =>
  import('~/pages/my-courses/ui/MyCoursesPage').then((module) => ({
    default: module.MyCoursesPage,
  })),
);

const MyCoursePage = lazy(() =>
  import('~/pages/my-course/ui/MyCoursePage').then((module) => ({
    default: module.MyCoursePage,
  })),
);
const SupportPage = lazy(() =>
  import('~/pages/support/ui/SupportPage').then((module) => ({
    default: module.SupportPage,
  })),
);
// Todo uncomment when students endpoints will be finished
// const MyStudentsPage = lazy(() =>
//   import('~/pages/my-students/ui/MyStudentsPage').then((module) => ({
//     default: module.MyStudentsPage,
//   })),
// );

// const MyStudentPage = lazy(() =>
//   import('~/pages/my-student/ui/MyStudentPage').then((module) => ({
//     default: module.MyStudentPage,
//   })),
// );

const ErrorPage = lazy(() =>
  import('~/pages/error/ui/ErrorPage').then((module) => ({
    default: module.ErrorPage,
  })),
);

const UnderConstructionPage = lazy(() =>
  import('~/pages/under-construction/ui/UnderConstructionPage').then(
    (module) => ({
      default: module.UnderConstructionPage,
    }),
  ),
);

const CallbackPage = lazy(() =>
  import('~/pages/callback/ui/CallbackPage').then((module) => ({
    default: module.CallbackPage,
  })),
);

const EmbeddedCoursePage = lazy(() =>
  import('~/pages/embedded-course/ui/EmbeddedCoursePage').then((module) => ({
    default: module.EmbeddedCoursePage,
  })),
);

const MyProfilePage = lazy(() =>
  import('~/pages/my-profile').then((module) => ({
    default: module.MyProfilePage,
  })),
);

export const router = createBrowserRouter([
  {
    id: 'root',
    errorElement: <ErrorPage />,
    children: [
      {
        element: (
          <>
            <ScrollToTop />
            <RootLayout />,
          </>
        ),
        children: [
          {
            index: true,
            element: <HomePage />,
          },
          {
            path: routes.dashboard.name,
            element: <DashboardLayout />,
            children: [
              {
                index: true,
                element: <DashboardPage />,
              },
              {
                path: routes.dashboard.support.name,
                element: <SupportPage />,
              },
              {
                path: routes.dashboard.courses.name,
                children: [
                  {
                    index: true,
                    element: <MyCoursesPage />,
                  },
                  {
                    path: routes.dashboard.courses.create.name,
                    element: <CreateCoursePage />,
                  },
                  {
                    path: routes.dashboard.courses.courseId.name,
                    children: [
                      {
                        index: true,
                        element: <MyCoursePage />,
                      },
                      {
                        path: routes.dashboard.courses.courseId.cards.name,
                        element: <CardsManagingPage />,
                      },
                    ],
                  },
                ],
              },
              // Todo uncomment when students endpoints will be finished
              // {
              //   path: routes.dashboard.students.name,
              //   children: [
              //     { index: true, element: <MyStudentsPage /> },
              //     {
              //       path: routes.dashboard.students.studentId.name,
              //       element: <MyStudentPage />,
              //     },
              //   ],
              // },
              {
                path: routes.dashboard.myProfile.name,
                element: <MyProfilePage />,
              },
            ],
          },
          {
            path: routes.underConstruction.name,
            element: <UnderConstructionPage />,
          },
          {
            path: routes.callback.name,
            element: <CallbackPage />,
          },
        ],
      },
      {
        path: routes.embeddedCourses.name,
        children: [
          {
            path: routes.embeddedCourses.courseId.name,
            element: <EmbeddedCoursePage />,
          },
        ],
      },
    ],
  },
]);
